import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "redux";

import { Button, Popover } from "antd";
import getColors from "../../../components/colors";

import axios from "axios";
import Chat, { options } from "./chat";
import LineGraph from "./Utilisation";
import CostGraph from "./cost";
import Header from "./header";
import Moment from "moment";
import { Url } from "./url";
import "./assets/css/index.css";
import moment from "moment";

import helper from "./assets/img/c-icon-2.png";
import onboard from "./assets/img/c-icon-1.png";
import refered from "./assets/img/c-icon-3.png";
import creator from "./assets/img/c-icon-4.png";

import bot from "../../../images/dashboard-icons/noun-bot.png";
import lifesaver from "../../../images/dashboard-icons/noun-lifesaver.png";
import note from "../../../images/dashboard-icons/noun-note.png";
import login from "../../../images/dashboard-icons/noun-login.png";
import business from "../../../images/dashboard-icons/business.png";
import group from "../../../images/dashboard-icons/group.png";
import clock from "../../../images/dashboard-icons/clock.png";

import trophy from "./assets/img/topicon.png";
import $, { data } from "jquery";
import { updateAnalyticsRecord } from "../../../redux/actions/analytics";
import runningIcon from "../../../images/brands/Progress.gif";
import Loader from "../../../components/loader";
import { Toolbar } from "@material-ui/core";
import PieChart from "./pieChart";
export class Analytics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      topMetrics: [],
      topcreatorsList: [],
      efforts: [],
      newcontent: [],
      utilization: [],
      processFlowData: [],
      customStartDate: null,
      customEndDate: null,
      isCustomDate: false,
      utilization: [],
      efforts: [],
      hoursSaved: 0,
      noOfSkillsExecuted: 0,
      isLoading: false,
      currentPath: "",
      activeCreators: [],
      skillStatus: [],
      getSkillSets: [],
      activeCreators: [],
      totalTeams: [],
      activeSubscriptions: [],
      revenue: 0,
      subscriptionStatus: [],
      totalUser: [],
      start_date: "",
      end_date: "",
      topQueries: [],
      topSkills: [],
      skillSentiments: [],
      sentimentData: [],
      skillExecutionStatusCount: [],
      skillExecutionStatuses: [],
      topIssues: [],
      isthumbsUpLabels: [],
      isThumbsUpCount: [],
      skillStatusColor: [],
      querySentimentColors: [],
    };
  }

  componentDidMount = () => {
    this.prepareFetch();
  };

  prepareFetch = async () => {
    this.setState({ currentPath: this.props.match.params.id });
    var startDate = new Date();
    var endDate = new Date();
    endDate.setDate(endDate.getDate() + 1);
    startDate.setDate(startDate.getDate() - 7);

    if (this.props.match.params.id != "admin") {
      this.setState({ isLoading: true });

      await this.fetchData(
        this.formatDate(startDate),
        this.formatDate(endDate),
        this.props.match.params.id
      );

      this.setState({ isLoading: false });
    } else {
      this.setState({ isLoading: true });

      await this.fetchData(
        this.formatDate(startDate),
        this.formatDate(endDate),
        null
      );
      this.setState({ isLoading: false });
    }
  };
  componentDidUpdate(nextProps, nextState) {
    if (this.state.currentPath !== this.props.match.params.id) {
      this.setState({ currentPath: this.props.match.params.id });
      this.prepareFetch();
    }
  }
  fetchData = async (
    start = null,
    end = null,
    orgId = null,
    loadData = false
  ) => {
    var dataToUpdate = [];
    var payload = {
      start_date: start == null ? "2022-01-11" : start,
      end_date: end == null ? Moment().format("YYYY-MM-DD") : end,
      orgId,
      loadData,
    };
    this.setState({
      start_date: payload.start_date,
      end_date: payload.end_date,
    });

    const instance = axios.create({
      baseURL: process.env.REACT_APP_ECS_HOST_URL + "/analytics/",
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: false,
    });

    const dashboardCards = await instance.post(`topmetrics`, payload);
    const topcreatorsList = await instance.post(`topcreators`, {
      start_date: start == null ? "2022-01-11" : start,
      end_date: end == null ? Moment().format("YYYY-MM-DD") : end,
      orgId,
    });

    if (dashboardCards.status) {
      this.setState({
        topMetrics: dashboardCards.data.data,
      });
      dataToUpdate.push(dashboardCards.data);
    } else {
      this.setState({
        topMetrics: [],
      });
    }
    const updatedTopCreatorsList = topcreatorsList.data.data.map((item) => {
      const profilePic = this.props?.userReducer?.user?.profilePic;

      return {
        ...item,
        profilePic: profilePic,
      };
    });
    if (topcreatorsList.status) {
      this.setState({
        topcreatorsList: updatedTopCreatorsList,
      });
    }
    const newcontent = await instance.post(`newcontent`, payload);
    if (newcontent.status) {
      this.setState({
        newcontent: newcontent.data.data,
      });
    }

    if (this.props.match.params.id == "admin") {
      const result = await instance.post(`hoursSaved`, payload);

      if (result.status) {
        this.setState({
          hoursSaved: result.data.data.timeSavedInHours,
          noOfSkillsExecuted: result.data.data.noOfSkillsExecuted,
        });
      } else {
        this.setState({
          hoursSaved: 0,
        });
      }
    } else {
      const result = await instance.post(`hoursSavedUser`, payload);

      if (result.status) {
        this.setState({
          hoursSaved: result.data.data.timeSavedInHours,
          noOfSkillsExecuted: result.data.data.noOfSkillsExecuted,
        });
      } else {
        this.setState({
          hoursSaved: 0,
        });
      }
    }

    // Total active creators/ creators created atleast one skill

    const activeCreators = await instance.post(`getActiveCreator`, payload);

    if (activeCreators.status) {
      this.setState({
        activeCreators: activeCreators.data.data,
      });
      dataToUpdate?.push(activeCreators.data.data[0]);
    } else {
      this.setState({
        activeCreators: [],
      });
    }

    // Total number of skillsets
    const getSkillSets = await instance.post(`getSkillSet`, payload);

    if (getSkillSets.status) {
      this.setState({
        getSkillSets: getSkillSets.data.data,
      });
      dataToUpdate.push(getSkillSets.data.data[0]);
    } else {
      this.setState({
        getSkillSets: [],
      });
    }
    //Number of skills by status (draft, published, waiting for approval)

    const skillStatus = await instance.post(`getSkillStatus`, payload);
    if (skillStatus.status) {
      this.setState({
        skillStatus: skillStatus.data.data,
      });
      dataToUpdate.push(skillStatus.data.data[0]);
    } else {
      this.setState({
        skillStatus: [],
      });
    }
    //Total number of users

    const totalUser = await instance.post(`getUsers`, payload);
    if (totalUser.status) {
      this.setState({
        totalUser: totalUser.data.data,
      });
      dataToUpdate.push(totalUser.data.data[0]);
    } else {
      this.setState({
        totalUser: [],
      });
    }

    // Total Teams

    const teamsData = await instance.post(`getTeams`, payload);

    if (teamsData.status) {
      this.setState({
        totalTeams: teamsData.data.data,
      });
      dataToUpdate.push(teamsData.data.data[0]);
    } else {
      this.setState({
        totalTeams: [],
      });
    }
    // Active Subscription Status
    const subscriptionData = await instance.post(`getSubscription`, payload);

    if (subscriptionData.status) {
      this.setState({
        activeSubscriptions: subscriptionData.data.data,
      });
    } else {
      this.setState({
        activeSubscriptions: [],
      });
    }

    // Revenue

    const revenueData = await instance.post(`getRevenue`, payload);
    if (revenueData.status) {
      this.setState({
        revenue: revenueData.data?.data[0]?.total_revenue,
      });
    } else {
      this.setState({
        revenue: 0,
      });
    }

    const subscriptionStatusData = await instance.post(
      `getCancelledSubs`,
      payload
    );

    if (subscriptionStatusData.status) {
      this.setState({
        subscriptionStatus: subscriptionStatusData.data.data,
      });
    } else {
      this.setState({
        subscriptionStatus: [],
      });
    }

    // Top 5 Skills used

    const topQueries = await instance.post(`getTopQueries`, payload);
    const topSkills = await instance.post(`getTopSkills`, payload);
    const skillSentiments = await instance.post(`skillSentiment`, payload);
    const skillExecutionByStatus = await instance.post(
      `skillExecutionByStatus`,
      payload
    );
    const topIssuesInQueries = await instance.post(`topIssuesQuery`, payload);
    const sentimentsAcrossQueries = await instance.post(
      `fetchSentimentsAcrossQueries`,
      payload
    );

    if (topQueries?.status) {
      this.setState({
        topQueries: topQueries?.data?.data,
      });
    } else {
      this.setState({
        topQueries: [],
      });
    }
    if (topSkills?.status) {
      this.setState({
        topSkills: topSkills?.data?.data,
      });
    } else {
      this.setState({
        topSkills: [],
      });
    }
    if (skillSentiments?.status) {
      let _sentimentsNumber = Object.values(skillSentiments?.data?.data);

      this.setState({
        skillSentiments: skillSentiments?.data?.data,
        sentimentData: _sentimentsNumber,
      });
    } else {
      this.setState({
        skillSentiments: [],
      });
    }

    if (skillExecutionByStatus?.status) {
      const statuses = skillExecutionByStatus?.data?.data.map(
        (item) => item.status
      );
      const statusColors = skillExecutionByStatus?.data?.data.map(
        (item) => item.color
      );
      const statusCounts = skillExecutionByStatus?.data?.data.map((item) =>
        parseInt(item.status_count)
      );
      this.setState({
        skillExecutionStatusCount: statusCounts,
        skillExecutionStatuses: statuses,
        skillStatusColor: statusColors,
      });
    } else {
      this.setState({
        skillExecutionStatusCount: [],
        skillExecutionStatuses: [],
        skillStatusColor: [],
      });
    }
    if (topIssuesInQueries?.status) {
      this.setState({
        topIssues: topIssuesInQueries?.data?.data,
      });
    } else {
      this.setState({
        topIssues: [],
      });
    }

    if (sentimentsAcrossQueries?.status) {
      const thumsUpLabels = sentimentsAcrossQueries?.data?.data?.map(
        (item) => item.isThumbsUp
      );
      const sentimentsColor = sentimentsAcrossQueries?.data?.data?.map(
        (item) => item.color
      );
      const thumbsUpCounts = sentimentsAcrossQueries?.data?.data?.map((item) =>
        parseInt(item.isthubsupcount)
      );
      this.setState({
        isthumbsUpLabels: thumsUpLabels,
        isThumbsUpCount: thumbsUpCounts,
        querySentimentColors: sentimentsColor,
      });
    } else {
      this.setState({
        isthumbsUpLabels: [],
        isThumbsUpCount: [],
        querySentimentColors: [],
      });
    }
    this.props.updateAnalyticsRecord(dataToUpdate);
  };

  formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  onDateChange = async (e) => {
    var d = new Date();
    var end = new Date();
    var endDate = end.setDate(end.getDate() + 1);
    if (e.target.value == "custom") {
      this.setState({ isCustomDate: true });
    } else {
      this.setState({ isCustomDate: false });
      if (e.target.value == 7) {
        d.setDate(d.getDate() - 7);
      } else {
        d.setMonth(d.getMonth() - e.target.value);
      }
      var orgId = this.props.match.params.id;
      // this.setState({ isLoading: true });
      this.fetchData(
        this.formatDate(d),
        this.formatDate(endDate),
        orgId != "admin" ? orgId : null
      );
      // this.setState({ isLoading: false });
    }
  };

  fetchCustomData = () => {
    var orgId = this.props.match.params.id;

    var end = new Date(this.state.customEndDate);
    var endDate = end.setDate(end.getDate() + 2);

    this.fetchData(
      this.state.customStartDate,
      this.formatDate(endDate),
      orgId != "admin" ? orgId : null
    );
  };

  redirectToViewPeople = (location) => {
    this.props.history.push("/settings/profile/viewPeople/" + location);
  };

  render() {
    const isAdmin = this.props.match.params.id == "admin" ? true : false;

    return (
      <div className={isAdmin ? "contentarea" : "contentarea scrollable"}>
        <div className="topTitleArea">
          <div className="title-btn">
            <div className="title-select">
              {isAdmin ? <h2>Admin Dashboard</h2> : <h2>Dashboard</h2>}

              <select
                onChange={(e) => {
                  this.onDateChange(e);
                }}
                name="cars"
                id="cars"
              >
                <option value="select">Select</option>
                <option selected="selected" value="7">
                  Last week
                </option>
                <option value="1">Last 1 months</option>
                <option value="3">Last 3 months</option>
                <option value="6">Last 6 months</option>
                <option value="custom">Custom</option>
              </select>
            </div>
            {/* <button
              className="btn btn-primary"
              onClick={() => {
                this.props.history.push("/dashboard/snippetCode");
              }}
            >
              Skill Snippets
            </button> */}
          </div>

          {this.state.isCustomDate ? (
            <div className="custom-date">
              <span>Start date : </span>
              <input
                type="date"
                max={moment().format("YYYY-MM-DD")}
                onChange={(e) => {
                  this.setState({ customStartDate: e.target.value });
                }}
              ></input>
              <span>End date : </span>
              <input
                type="date"
                max={moment().format("YYYY-MM-DD")}
                onChange={(e) => {
                  this.setState({ customEndDate: e.target.value });
                }}
              ></input>

              <button
                className="btn btn-primary"
                onClick={() => {
                  this.fetchCustomData();
                }}
              >
                Fetch Analytics
              </button>
            </div>
          ) : null}
        </div>
        {this.state.isLoading ? (
          <Loader
            styles={{ width: "80px", margin: "auto" }}
            root={{ display: "flex" }}
          />
        ) : (
          <>
            <div className="main-dashboard">
              <div className="dashboard-inner">
                {isAdmin ? (
                  <>
                    <div className="row db-cols">
                      <div className="col-md-12">
                        <div className="row db-first-row">
                          {/* Row 1 */}
                          <div
                            className="col-md-4 no-pdr-col"
                            onClick={() =>
                              this.props.history.push(
                                `/settings/profile/viewPeople/5?i=skill_sets&${this.state.start_date}&${this.state.end_date}`
                              )
                            }
                          >
                            <div className="db-outer">
                              <div className="db-text">
                                <h2>
                                  {this.state?.getSkillSets[0]?.total_skillset
                                    ? this.state?.getSkillSets[0]
                                        ?.total_skillset
                                    : 0}
                                </h2>
                                <p>Total Skills set</p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-md-4"
                            onClick={() =>
                              this.props.history.push(
                                `/settings/profile/viewPeople/11?i=skill_execution&${this.state.start_date}&${this.state.end_date}`
                              )
                            }
                          >
                            <div className="db-outer">
                              <div className="db-text">
                                <h2>
                                  {this.state.topMetrics &&
                                  this.state.topMetrics.length > 0
                                    ? this.state.noOfSkillsExecuted
                                    : 0}
                                </h2>
                                <p>Skill Executions</p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-md-4"
                            onClick={() =>
                              this.props.history.push(
                                `/settings/profile/viewPeople/6?i=skills&${this.state.start_date}&${this.state.end_date}`
                              )
                            }
                          >
                            <div className="db-outer">
                              <div className="db-text">
                                <h2>
                                  {this.state.topMetrics &&
                                  this.state.topMetrics.length > 0
                                    ? parseInt(
                                        this.state.topMetrics[0].user_doc_count
                                      ) +
                                      parseInt(
                                        this.state.topMetrics[0]
                                          .walk_skill_count
                                      ) +
                                      parseInt(
                                        this.state.topMetrics[0]
                                          .import_spreadsheet_count
                                      ) +
                                      parseInt(
                                        this.state.topMetrics[0]
                                          .web_automation_count
                                      ) +
                                      parseInt(
                                        this.state.topMetrics[0]
                                          .user_onboard_count
                                      ) +
                                      parseInt(
                                        this.state.topMetrics[0].skill_set_count
                                      ) +
                                      parseInt(
                                        this.state.topMetrics[0]
                                          .blank_template_count
                                      )
                                    : 0}
                                </h2>
                                <p>Total Skills</p>
                              </div>
                            </div>
                          </div>
                          {/* <div
                            className="col-md-3 no-pdl-col"
                            onClick={() =>
                              this.props.history.push(
                                `/settings/profile/viewPeople/7?i=creators&${this.state.start_date}&${this.state.end_date}`
                              )
                            }
                          >
                            <div className="db-outer">
                              <div
                                className="db-icon"
                                style={{
                                  backgroundColor: "#e6fdff",
                                  borderColor: "#0dd7e6",
                                }}
                              >
                                <img src={business} />
                              </div>
                              <div className="db-text">
                                <h2>
                                  {" "}
                                  {this.state.topMetrics &&
                                  this.state.topMetrics.length > 0
                                    ? this.state.topMetrics[0].creator_count
                                    : 0}
                                </h2>
                                <p>Total Creators</p>
                              </div>
                            </div>
                          </div> */}
                        </div>
                        <div className="row db-second-row">
                          {/* Row 2 */}
                          <div className="col-md-3">
                            <div className="db-outer">
                              <div className="db-text">
                                <h2>{this.state.revenue || 0}</h2>
                                <p>Total Revenue</p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-md-3"
                            onClick={() =>
                              this.props.history.push(
                                `/settings/profile/viewPeople/8?i=users&${this.state.start_date}&${this.state.end_date}`
                              )
                            }
                          >
                            <div className="db-outer">
                              <div className="db-text">
                                <h2>
                                  {" "}
                                  {this.state.topMetrics &&
                                  this.state.totalUser.length > 0
                                    ? this.state.totalUser[0].total_users
                                    : 0}
                                </h2>
                                <p>Total Users</p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-md-3"
                            onClick={() =>
                              this.props.history.push(
                                `/settings/profile/viewPeople/9?i=teams&${this.state.start_date}&${this.state.end_date}`
                              )
                            }
                          >
                            <div className="db-outer">
                              <div className="db-text">
                                <h2>
                                  {this.state.topMetrics &&
                                  this.state.totalTeams.length > 0
                                    ? this.state.totalTeams[0].total_teams
                                    : 0}
                                </h2>
                                <p>Total Teams</p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-md-3"
                            onClick={() =>
                              this.props.history.push(
                                `/settings/profile/viewPeople/10?i=active_creators&${this.state.start_date}&${this.state.end_date}`
                              )
                            }
                          >
                            <div className="db-outer">
                              <div className="db-text">
                                <h2>
                                  {" "}
                                  {this.state.activeCreators &&
                                  this.state.activeCreators.length > 0
                                    ? this.state.activeCreators[0]
                                        .active_creators
                                    : 0}
                                </h2>
                                {/* <p>Active Creators</p> */}
                                <p>Total Creators</p>
                              </div>
                            </div>
                          </div>
                          {/* End of Row 2 */}
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="row db-cols">
                    <div className="col-md-12">
                      <div className="row">
                        <div
                          className="col-md-3"
                          onClick={() =>
                            this.props.history.push(
                              `/settings/profile/viewPeople/12?orgId=${this.props.match.params.id}&${this.state.start_date}&${this.state.end_date}`
                            )
                          }
                        >
                          <div className="db-outer">
                            <div className="db-text">
                              <h2>
                                {this.state.topMetrics &&
                                this.state.topMetrics.length > 0
                                  ? parseInt(
                                      this.state.topMetrics[0].user_doc_count
                                    ) +
                                    parseInt(
                                      this.state.topMetrics[0].walk_skill_count
                                    ) +
                                    parseInt(
                                      this.state.topMetrics[0]
                                        .import_spreadsheet_count
                                    ) +
                                    parseInt(
                                      this.state.topMetrics[0]
                                        .web_automation_count
                                    ) +
                                    parseInt(
                                      this.state.topMetrics[0]
                                        .user_onboard_count
                                    ) +
                                    parseInt(
                                      this.state.topMetrics[0].skill_set_count
                                    ) +
                                    parseInt(
                                      this.state.topMetrics[0]
                                        .blank_template_count
                                    )
                                  : 0}
                              </h2>
                              <p> Agents Created/Added</p>
                            </div>
                          </div>
                        </div>
                        <div
                          className="col-md-3"
                          onClick={() =>
                            this.props.history.push(
                              `/settings/profile/viewPeople/11?orgId=${this.props.match.params.id}&i=skill_execution&${this.state.start_date}&${this.state.end_date}`
                            )
                          }
                        >
                          <div className="db-outer">
                            <div className="db-text">
                              <h2>
                                {this.state.topMetrics &&
                                this.state.topMetrics.length > 0
                                  ? this.state.noOfSkillsExecuted
                                  : 0}
                              </h2>
                              <p>Agents Executions </p>
                            </div>
                          </div>
                        </div>
                        <div
                          className="col-md-3"
                          onClick={() =>
                            this.props.history.push(
                              `/settings/profile/viewPeople/7?orgId=${this.props.match.params.id}&${this.state.start_date}&${this.state.end_date}`
                            )
                          }
                        >
                          <div className="db-outer">
                            <div className="db-text">
                              <h2>
                                {this.state.topMetrics &&
                                this.state.topMetrics.length > 0
                                  ? this.state.topMetrics[0].creator_count
                                  : 0}
                              </h2>
                              <p>Creators</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* 
1 - user signed up info 
2 -   Users Installed Dependencies
3 -  Skill Executions
4 - Skills Created/Added
5- total skillset info
6- total skills 
7-total creators
8-total users
9- total teams
10- active creators
11- skill status info 

*/}
                {isAdmin ? (
                  <div className="listboxSec">
                    <div
                      className="lbCol col-md-3"
                      onClick={() =>
                        this.props.history.push(
                          `/settings/profile/viewPeople/1?i=user_singned_up&${this.state.start_date}&${this.state.end_date}`
                        )
                      }
                    >
                      {/* <img src={onboard} /> */}
                      <div className="lbcolInner">
                        <h1>
                          {this.state.topMetrics &&
                          this.state.topMetrics.length > 0
                            ? this.state?.topMetrics[1]?.user_count
                            : 0}
                        </h1>
                        <p>Users Signed Up</p>
                      </div>
                    </div>
                    <div
                      className="lbCol col-md-3"
                      onClick={() =>
                        this.props.history.push(
                          `/settings/profile/viewPeople/2?i=user_installation&${this.state.start_date}&${this.state.end_date}`
                        )
                      }
                    >
                      {/* <img src={onboard} /> */}
                      <div className="lbcolInner">
                        <h1>
                          {this.state.topMetrics &&
                          this.state.topMetrics.length > 0
                            ? this.state?.topMetrics[2]?.installed_dep
                            : 0}{" "}
                          / {this.state?.topMetrics[1]?.user_count}
                        </h1>
                        <p>Users Installed Dependencies</p>
                      </div>
                    </div>
                    <div
                      className="lbCol col-md-3"
                      onClick={() =>
                        this.props.history.push(
                          `/settings/profile/viewPeople/3?i=skill_execution&${this.state.start_date}&${this.state.end_date}`
                        )
                      }
                    >
                      {/* <img src={onboard} /> */}
                      <div className="lbcolInner">
                        <h1>
                          {this.state.topMetrics &&
                          this.state.topMetrics.length > 0
                            ? this.state?.topMetrics[3]?.users_skills_used
                            : 0}{" "}
                          / {this.state?.topMetrics[1]?.user_count}
                        </h1>
                        <p>Skill Executions</p>
                      </div>
                    </div>
                    <div
                      className="lbCol col-md-3"
                      style={{ width: "20%" }}
                      onClick={() =>
                        this.props.history.push(
                          `/settings/profile/viewPeople/4?i=skill_added&${this.state.start_date}&${this.state.end_date}`
                        )
                      }
                    >
                      {/* <img src={onboard} /> */}
                      <div className="lbcolInner">
                        <h1>
                          {this.state.topMetrics &&
                          this.state.topMetrics.length > 0
                            ? this.state?.topMetrics[4]?.drafts_count
                            : 0}{" "}
                          / {this.state?.topMetrics[1]?.user_count}
                        </h1>
                        <p> Skills Created/Added</p>
                      </div>
                    </div>
                  </div>
                ) : null}

                {/* Top Creators */}

                {/* <div className="row tc-list-outer">
                  <div className="col-md-12">
                    <hr />
                    <h4>Top Creators</h4>
                    {this.state.topcreatorsList &&
                    this.state.topcreatorsList.length > 0 ? (
                      <ul className="tc-list">
                        {this.state.topcreatorsList?.length > 0 &&
                          this.state.topcreatorsList
                            .slice(0, 15)
                            .map((item) => (
                              <li key={item.rn}>
                                <Popover
                                  content={
                                    <div className="top-details">
                                      <p>
                                        Rank : <strong>{item.rn}</strong>
                                      </p>
                                      <p>
                                        Skills Created :{" "}
                                        <strong>{item.skill_count}</strong>
                                      </p>
                                    </div>
                                  }
                                  title={
                                    item.user_name ? item.user_name : item.email
                                  }
                                >
                                  {this.props.userReducer.user &&
                                  item.email ===
                                    this.props.userReducer.user.email &&
                                  item.profilePic ? (
                                    <img
                                      src={item?.profilePic}
                                      width="60"
                                      height="60"
                                    />
                                  ) : (
                                    <div className="userIconText">
                                      <span>
                                        {item?.user_name
                                          ? item?.user_name.slice(0, 2)
                                          : item?.email.slice(0, 2)}
                                      </span>
                                    </div>
                                  )}
                                </Popover>
                              </li>
                            ))}
                      </ul>
                    ) : (
                      <h5 className="text-center">No Data Found</h5>
                    )}
                    <hr />
                  </div>
                </div> */}

                {/* Updated Dashboard Design */}
                <div className="row updated-dashbord">
                  {/* First Row */}
                  {isAdmin ? null : (
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="boxbg dash-box">
                            <div className="titleB">
                              <h4>Top 5 Agents used</h4>
                            </div>
                            <div className="boxbg-content scrollbox-h180">
                              <ul className="list-li">
                                {this.state.topSkills?.length > 0 ? (
                                  <>
                                    {this.state.topSkills?.map((item) => (
                                      <li>{item.SKILL_NAME}</li>
                                    ))}
                                  </>
                                ) : (
                                  <h5 className="text-center">No Data Found</h5>
                                )}
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="boxbg dash-box">
                            <div className="titleB">
                              <h4>Top 5 Queries Asked</h4>
                            </div>
                            <div className="boxbg-content scrollbox-h180">
                              <ul className="list-li">
                                {this.state.topQueries?.length > 0 ? (
                                  <>
                                    {" "}
                                    {this.state.topQueries?.map((item) => (
                                      <li>{item.question}</li>
                                    ))}
                                  </>
                                ) : (
                                  <h5 className="text-center">No Data Found</h5>
                                )}
                              </ul>
                            </div>
                          </div>
                        </div>{" "}
                      </div>
                    </div>
                  )}

                  {/* Second Row */}

                  <div className="col-md-12">
                    <div className="row">
                      {isAdmin ? null : (
                        <>
                          {" "}
                          <div className="col-md-6">
                            <div className="boxbg dash-box">
                              <div className="titleB">
                                <h4>Top 5 Issues Reported</h4>
                              </div>
                              <div className="boxbg-content scrollbox-h250">
                                <ul className="list-li">
                                  {this.state.topIssues?.length > 0 ? (
                                    <>
                                      {" "}
                                      {this.state.topIssues?.map((item) => (
                                        <li>{item.question}</li>
                                      ))}
                                    </>
                                  ) : (
                                    <h5 className="text-center">
                                      No Data Found
                                    </h5>
                                  )}
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="boxbg dash-box">
                              <div className="titleB">
                                <h4>Sentiments Across Queries</h4>
                              </div>

                              <div className="boxbg-content scrollbox-h250">
                                {this.state.isThumbsUpCount?.length ? (
                                  <PieChart
                                    data={this.state}
                                    type="querySentiments"
                                  />
                                ) : (
                                  <h5 className="text-center">No Data Found</h5>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  {/* Third Row */}
                  <div className="col-md-12">
                    <div className="row">
                      {isAdmin ? null : (
                        <div className="col-md-6">
                          <div className="boxbg dash-box">
                            <div className="titleB">
                              <h4>Sentiments Across Agents</h4>
                            </div>

                            <div className="boxbg-content scrollbox-h250">
                              {this.state.sentimentData?.length ? (
                                <PieChart
                                  data={this.state.sentimentData}
                                  type="skillSentiments"
                                />
                              ) : (
                                <h5 className="text-center">No Data Found</h5>
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Skill Status count  */}

                      {isAdmin ? null : (
                        <div className="col-md-6">
                          <div className="boxbg dash-box">
                            <div className="titleB">
                              <h4>Agents By Status</h4>
                            </div>

                            <div className="boxbg-content scrollbox-h250">
                              {this.state.skillExecutionStatusCount?.length ? (
                                <PieChart
                                  data={this.state}
                                  type="skillExecutionStatus"
                                />
                              ) : (
                                <h5 className="text-center">No Data Found</h5>
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                      {/* {isAdmin ? null : (
                        <div className="col-md-6">
                          <div className="boxbg dash-box">
                            <div className="titleB">
                              <h4>New Content Created</h4>
                            </div>
                            <div className="boxbg-content scrollbox-h250">
                              <Chat newcontent={this.state.newcontent}></Chat>
                            </div>
                          </div>
                        </div>
                      )} */}
                    </div>
                  </div>
                </div>

                {/* Third Row */}

                <div className="boxsecN flex-stretch">
                  {isAdmin ? (
                    <div className="boxW71 boxbg">
                      <div className="titleB">
                        <h4>New Content Created</h4>
                      </div>
                      <div className="grapcol">
                        <Chat newcontent={this.state.newcontent}></Chat>
                      </div>
                    </div>
                  ) : null}

                  {/* New Design  */}

                  {/*Old design */}
                  {isAdmin ? (
                    <div className="box-two-blocks boxW27">
                      <div className="box boxbg box-h300">
                        <div className="titleB">
                          <h4>Agent Matrix</h4>
                        </div>
                        <div className="toplist">
                          <div className="scrollbar">
                            <ul className="matrix-list">
                              {this.state.skillStatus?.length > 0 &&
                                this.state.skillStatus.map((item) => (
                                  <>
                                    {item.status == "self" && (
                                      <li
                                      // onClick={() =>
                                      //   this.props.history.push(
                                      //     `/settings/profile/viewPeople/6?status=self&${this.state.start_date}&${this.state.end_date}`
                                      //   )
                                      // }
                                      >
                                        <p>Self</p>
                                        <h4>{item.count ? item.count : 0}</h4>
                                      </li>
                                    )}
                                    {item.status == "approved" && (
                                      <li
                                      // onClick={() =>
                                      //   this.props.history.push(
                                      //     `/settings/profile/viewPeople/6?status=approved&${this.state.start_date}&${this.state.end_date}`
                                      //   )
                                      // }
                                      >
                                        <p>Approved</p>
                                        <h4>{item.count ? item.count : 0}</h4>
                                      </li>
                                    )}{" "}
                                    {item.status == "pending" && (
                                      <li
                                      // onClick={() =>
                                      //   this.props.history.push(
                                      //     `/settings/profile/viewPeople/6?status=pending&${this.state.start_date}&${this.state.end_date}`
                                      //   )
                                      // }
                                      >
                                        <p>Waiting for Approval</p>
                                        <h4>{item.count ? item.count : 0}</h4>
                                      </li>
                                    )}
                                    {item.status == "published" && (
                                      <li
                                      // onClick={() =>
                                      //   this.props.history.push(
                                      //     `/settings/profile/viewPeople/6?status=published&${this.state.start_date}&${this.state.end_date}`
                                      //   )
                                      // }
                                      >
                                        <p>Published</p>
                                        <h4>{item.count ? item.count : 0}</h4>
                                      </li>
                                    )}
                                    {item.status == "declined" && (
                                      <li
                                      // onClick={() =>
                                      //   this.props.history.push(
                                      //     `/settings/profile/viewPeople/6?status=declined&${this.state.start_date}&${this.state.end_date}`
                                      //   )
                                      // }
                                      >
                                        <p>Declined</p>
                                        <h4>{item.count ? item.count : 0}</h4>
                                      </li>
                                    )}
                                  </>
                                ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="box boxbg box-h300">
                        <div className="titleB">
                          <h4>Subscription Matrix</h4>
                        </div>
                        <div className="toplist">
                          <div className="scrollbar">
                            <ul className="matrix-list">
                              {this.state.activeSubscriptions &&
                                this.state.activeSubscriptions.length > 0 &&
                                this.state.activeSubscriptions.map((item) => (
                                  <>
                                    {item.planId == "4" && (
                                      <li>
                                        <p>Team</p>
                                        <h4>{item.count ? item.count : 0}</h4>
                                      </li>
                                    )}
                                    {item.planId == "5" && (
                                      <li>
                                        <p>Business</p>
                                        <h4>{item.count ? item.count : 0}</h4>
                                      </li>
                                    )}
                                  </>
                                ))}{" "}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : // <div className="box boxbg box-h300">
                  //   <div className="titleB">
                  //     <h4>
                  //       <img src={trophy} style={{ width: "16px" }} />
                  //       &nbsp;Top Creators
                  //     </h4>
                  //   </div>

                  //   <div className="toplist">
                  //     <div className="scrollbar">
                  //       {this.state.topcreatorsList &&
                  //       this.state.topcreatorsList.length > 0 ? (
                  //         <ul>
                  //           {this.state.topcreatorsList &&
                  //             this.state.topcreatorsList.map((item) => (
                  //               <li ky={item.rn}>
                  //                 <div className="tcimg">
                  //                   {this.props.userReducer.user &&
                  //                   item.email ===
                  //                     this.props.userReducer.user.email &&
                  //                   item.profilePic ? (
                  //                     <img
                  //                       src={item?.profilePic}
                  //                       width="30"
                  //                       height="30"
                  //                     />
                  //                   ) : (
                  //                     <div className="userIconText">
                  //                       <span>
                  //                         {item?.user_name
                  //                           ? item?.user_name.slice(0, 2)
                  //                           : item?.email.slice(0, 2)}
                  //                       </span>
                  //                     </div>
                  //                   )}
                  //                   <h3
                  //                     title={
                  //                       item.user_name
                  //                         ? item.user_name
                  //                         : item.email
                  //                     }
                  //                   >
                  //                     {item.user_name
                  //                       ? item.user_name
                  //                       : item.email}
                  //                   </h3>
                  //                 </div>

                  //                 <div className="tcaction">
                  //                   <span>{item.skill_count}</span>
                  //                   <i>{item.rn}</i>

                  //                   <img
                  //                     src="/assets/img/tc-mark-1.png"
                  //                     width="13"
                  //                     height="17"
                  //                   />
                  //                 </div>
                  //               </li>
                  //             ))}
                  //         </ul>
                  //       ) : (
                  //         <h5 className="text-center">No Data Found</h5>
                  //       )}
                  //     </div>
                  //   </div>
                  // </div>
                  null}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  skills: state.skillReducer,
  userReducer: state.userReducer,
  searchTerm: state.searchTerm,
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    updateAnalyticsRecord,
  })
)(Analytics);
